import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest.ts';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.PAGE,
    name: 'usage-statistics',
    exclusiveRoutePath: '/usage-statistics',
    getComponent: () => import('./UsageStatistics.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};
